import { component } from "picoapp";

export default component((node) => {
  const open = (orderEl) => {
    orderEl.classList.remove("closed");
    orderEl.classList.add("open");
    const toggleEl = orderEl.querySelector(".customer-order-toggle");
    toggleEl.innerHTML = "CLOSE";
  };

  const close = (orderEl) => {
    orderEl.classList.remove("open");
    orderEl.classList.add("closed");
    const toggleEl = orderEl.querySelector(".customer-order-toggle");
    toggleEl.innerHTML = "DETAILS";
  };

  const toggle = node.querySelector(".customer-order-toggle");
  toggle.addEventListener("click", function () {
    if (node.classList.contains("open")) {
      close(node);
    } else {
      open(node);
    }
  });
});
